import Moment from 'moment';
import momenttz from 'moment-timezone';

//Format eg. 28-01-2023
export const formatDD_MM_YYYY = (date) => {
    if(!date) return '--/--/----';
    let datetz = Moment(date).tz("Asia/Kuala_Lumpur")
    return Moment(datetz, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD')
}

//Format eg. 2023-01-28
export const formatYYYY_MM_DD = (date) => {
    if(!date) return '--/--/----';
    let datetz = Moment(date).tz("Asia/Kuala_Lumpur")
    return Moment(datetz, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD')
}

//Format eg. 2023-01-28 14:12
export const formatYYYY_MM_DD_HH_mm = (date) => {
    if(!date) return '--/--/----';
    let datetz = Moment(date).tz("Asia/Kuala_Lumpur")
    return Moment(datetz, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm')
}